export const MOUSE_CONSTRAINT_DISTANCE = 10;
